import { render, staticRenderFns } from "./UnifiedPaginationPageIcon.vue?vue&type=template&id=2e0542cc"
import script from "./UnifiedPaginationPageIcon.vue?vue&type=script&lang=js"
export * from "./UnifiedPaginationPageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports